import React from 'react'
import * as S from './styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import classNames from 'classnames'

const Checkbox = props => (
    <>
        <S.Checkbox className="form-group">
            {props.label && <span className="checkbox-label !mb-1">{props.label}</span>}
            <input
                type="checkbox"
                {...props}
                data-testid={`label-${props.label.toLowerCase().replaceAll(' ', '-')}`}
            />
            <span
                className="checkbox"
                data-testid={`checkbox-${props.label.toLowerCase().replaceAll(' ', '-')}`}
            ></span>

            {props.tooltip && (
                <span
                    data-tooltip={props.tooltip}
                    className={classNames('!ml-2', {
                        'tooltip-wrap': props.tooltip.length > 50,
                    })}
                >
                    <FontAwesomeIcon icon={faInfoCircle} />
                </span>
            )}
        </S.Checkbox>

        {props.help && (
            <span
                style={{
                    display: 'block',
                    fontSize: '12px',
                    lineHeight: 1.4,
                    color: '#999',
                    marginTop: '-0.25rem',
                    marginBottom: '0.5rem',
                }}
            >
                {props.help}
            </span>
        )}
    </>
)

export default Checkbox
